import { conLanding } from "../../Panel/Models/Landing";
import { Eventos as c } from "../Custom/Eventos";

export default class Eventos extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}